import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { http, fmt } from "@/lib/api";
import { StarsDisplay, RateStars } from "@/components/StarRating";
import { VideoCard } from "@/components/VideoCard";
import { YT } from "@/constants/testIds";

const FAKE_COMMENT_AVATARS = [
  "#c33", "#3a7", "#36c", "#a3a", "#c93", "#690", "#c63", "#369",
];
const initialFakeComments = (videoId) => [
  {
    id: "f1",
    author: "xXxSk8erBoi92xXx",
    text: "first!! lol",
    thumbs_up: 12,
    thumbs_down: 3,
    created_at: new Date(Date.now() - 1000 * 60 * 8).toISOString(),
    fake: true,
  },
  {
    id: "f2",
    author: "MLGProGamer",
    text: "this is the best video i seen all day. subbed",
    thumbs_up: 27,
    thumbs_down: 1,
    created_at: new Date(Date.now() - 1000 * 60 * 45).toISOString(),
    fake: true,
  },
  {
    id: "f3",
    author: "lilmissunshine87",
    text: "omg lolzzz xD ROFLCOPTER. 5 stars!!",
    thumbs_up: 9,
    thumbs_down: 0,
    created_at: new Date(Date.now() - 1000 * 60 * 60 * 3).toISOString(),
    fake: true,
  },
  {
    id: "f4",
    author: "darklord1337",
    text: "PLEASE check out my channel i make videos too",
    thumbs_up: 0,
    thumbs_down: 18,
    created_at: new Date(Date.now() - 1000 * 60 * 60 * 26).toISOString(),
    fake: true,
  },
];

export default function Watch() {
  const { videoId } = useParams();
  const [video, setVideo] = useState(null);
  const [related, setRelated] = useState([]);
  const [comments, setComments] = useState([]);
  const [rating, setRating] = useState({ average: 0, count: 0 });
  const [myRating, setMyRating] = useState(0);
  const [author, setAuthor] = useState("");
  const [text, setText] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    let alive = true;
    setVideo(null);
    Promise.all([
      http.get(`/videos/${videoId}`),
      http.get(`/videos`),
      http.get(`/videos/${videoId}/comments`).catch(() => ({ data: [] })),
      http.get(`/videos/${videoId}/rating`).catch(() => ({ data: { average: 0, count: 0 } })),
    ]).then(([v, all, c, r]) => {
      if (!alive) return;
      setVideo(v.data);
      setRelated(
        (all.data || [])
          .filter((x) => x.video_id !== videoId)
          .slice(0, 8)
      );
      setComments([...c.data, ...initialFakeComments(videoId)]);
      setRating(r.data);
    });
    return () => {
      alive = false;
    };
  }, [videoId]);

  const submitRating = async (stars) => {
    setMyRating(stars);
    const { data } = await http.post(`/videos/${videoId}/rate`, {
      video_id: videoId,
      stars,
    });
    setRating(data);
  };

  const submitComment = async (e) => {
    e.preventDefault();
    if (!author.trim() || !text.trim()) return;
    setSubmitting(true);
    try {
      const { data } = await http.post(`/videos/${videoId}/comments`, {
        video_id: videoId,
        author: author.trim(),
        text: text.trim(),
      });
      setComments((cur) => [data, ...cur]);
      setText("");
    } finally {
      setSubmitting(false);
    }
  };

  if (!video) {
    return <div style={{ padding: 24 }}>Loading video…</div>;
  }

  return (
    <div data-testid={YT.watchPage}>
      <div className="yt-watch">
        {/* Main column */}
        <div>
          <div className="yt-section">
            <div
              className="yt-player"
              data-testid={YT.player}
            >
              <iframe
                src={`https://www.youtube.com/embed/${video.video_id}?rel=0&modestbranding=1`}
                title={video.title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
            <div style={{ padding: 10 }}>
              <h1 style={{ fontSize: 16, margin: "0 0 4px 0", color: "#222" }}>
                {video.title}
              </h1>
              <div className="yt-meta">
                <b>{fmt.views(video.views)}</b> views &middot; uploaded{" "}
                {fmt.ago(video.published)} &middot; by{" "}
                <Link to="/channel">John Casterline</Link>
              </div>
              <div
                style={{
                  marginTop: 10,
                  paddingTop: 8,
                  borderTop: "1px solid #e3e3e3",
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "center",
                  gap: 10,
                }}
              >
                <span style={{ color: "#333" }}>
                  <b>YouTube Rating:</b>
                </span>
                <StarsDisplay
                  value={video.star_average}
                  count={video.star_count}
                />
                <span style={{ marginLeft: 18, color: "#333" }}>
                  <b>Rate this video:</b>
                </span>
                <RateStars value={myRating} onRate={submitRating} />
                {rating.count > 0 ? (
                  <span style={{ color: "#666" }}>
                    Site avg: <b>{rating.average}</b> ({rating.count})
                  </span>
                ) : null}
              </div>
            </div>
          </div>

          {/* Comments */}
          <div className="yt-section">
            <div className="yt-section-title">
              Comments &amp; Responses ({comments.length})
            </div>
            <div className="yt-section-body">
              <form
                onSubmit={submitComment}
                className="yt-comment"
                data-testid={YT.commentForm}
                style={{ borderTop: 0 }}
              >
                <div
                  className="yt-comment-avatar"
                  style={{ background: "#888" }}
                >
                  ?
                </div>
                <div>
                  <input
                    className="yt-input"
                    placeholder="your name"
                    value={author}
                    maxLength={40}
                    onChange={(e) => setAuthor(e.target.value)}
                    data-testid={YT.commentAuthor}
                    style={{ marginBottom: 5 }}
                  />
                  <textarea
                    className="yt-textarea"
                    placeholder="post a comment…"
                    value={text}
                    maxLength={600}
                    onChange={(e) => setText(e.target.value)}
                    data-testid={YT.commentText}
                  />
                  <div
                    style={{
                      marginTop: 6,
                      display: "flex",
                      gap: 6,
                      alignItems: "center",
                    }}
                  >
                    <button
                      type="submit"
                      className="yt-btn"
                      disabled={submitting}
                      data-testid={YT.commentSubmit}
                    >
                      {submitting ? "Posting…" : "Post comment"}
                    </button>
                    <span style={{ color: "#888" }}>
                      Be kind. It's 2008 in here.
                    </span>
                  </div>
                </div>
              </form>

              <div data-testid={YT.commentList}>
                {comments.map((c, i) => (
                  <div className="yt-comment" key={c.id || i}>
                    <div
                      className="yt-comment-avatar"
                      style={{
                        background:
                          FAKE_COMMENT_AVATARS[
                            i % FAKE_COMMENT_AVATARS.length
                          ],
                      }}
                    >
                      {c.author.slice(0, 1).toUpperCase()}
                    </div>
                    <div>
                      <div>
                        <span className="yt-comment-author">{c.author}</span>
                        <span className="yt-comment-when">
                          {fmt.ago(c.created_at)}
                        </span>
                      </div>
                      <div className="yt-comment-text">{c.text}</div>
                      <div className="yt-comment-actions">
                        <a href="#">Reply</a>
                        <span style={{ color: "#aaa" }}>
                          {(c.thumbs_up ?? 0) > 0
                            ? `▲ ${c.thumbs_up}`
                            : "▲ 0"}{" "}
                          / ▼ {c.thumbs_down ?? 0}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Sidebar */}
        <div>
          <div className="yt-section">
            <div className="yt-section-title">Related Videos</div>
            <div className="yt-section-body" style={{ display: "grid", gap: 10 }}>
              {related.map((v) => (
                <div
                  key={v.video_id}
                  style={{
                    display: "grid",
                    gridTemplateColumns: "100px 1fr",
                    gap: 8,
                  }}
                >
                  <Link to={`/watch/${v.video_id}`} className="yt-thumb-wrap">
                    <img src={v.thumbnail} alt={v.title} />
                    {v.is_short ? (
                      <span className="yt-thumb-short">SHORT</span>
                    ) : null}
                  </Link>
                  <div>
                    <Link
                      to={`/watch/${v.video_id}`}
                      style={{ fontSize: 11, fontWeight: "bold" }}
                    >
                      {v.title.length > 50
                        ? v.title.slice(0, 50) + "…"
                        : v.title}
                    </Link>
                    <div className="yt-meta" style={{ marginTop: 3 }}>
                      <b>{fmt.shortViews(v.views)}</b> views
                      <br />
                      <StarsDisplay
                        value={v.star_average}
                        count={v.star_count}
                        showCount={false}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
